<template>
  <v-speed-dial v-model="fab" direction="right" transition="slide-x-transition" style="max-width: fit-content"
                class="ms-auto">
    <template v-slot:activator>
      <v-btn v-model="fab" fab small class="ms-auto">
        <v-icon v-if="fab">mdi-close</v-icon>
        <v-icon v-else>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-tooltip top>
      <template v-slot:activator="{on, attr}">
        <v-btn fab small color="info" @click="click(data, 'updateStatus')" v-on="on" v-bind="attr">
          <v-icon color="white">mdi-{{ data.status === 'active' ? 'pause-circle-outline' : 'play-circle' }}</v-icon>
        </v-btn>
      </template>

      <span>{{ data.status === 'active' ? 'غیرفعال کردن' : 'فعال کردن' }}</span>
    </v-tooltip>

    <v-tooltip top>
      <template v-slot:activator="{on, attr}">
        <v-btn fab small color="third" @click="click(data, 'destroy')" v-on="on" v-bind="attr">
          <v-icon color="white">mdi-delete</v-icon>
        </v-btn>
      </template>

      <span>حذف دامنه</span>
    </v-tooltip>
  </v-speed-dial>
</template>

<script>
export default {
  name: "domainButtons",

  props: {
    data: Object,
    click: Function
  },

  data: () => ({
    fab: false
  })
}
</script>

<style scoped>

</style>